import { render, staticRenderFns } from "./OpenDentalDataConfigView.vue?vue&type=template&id=3f9fcfb6&scoped=true"
import script from "./OpenDentalDataConfigView.vue?vue&type=script&lang=js"
export * from "./OpenDentalDataConfigView.vue?vue&type=script&lang=js"
import style0 from "./OpenDentalDataConfigView.vue?vue&type=style&index=0&id=3f9fcfb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9fcfb6",
  null
  
)

export default component.exports